module.exports = __webpack_public_path__ + "files/449f0e789d8849a167612571d0b43622.png";